const Constant = {
  APP_LOGO: "\u{1f984}",
  APP_NAME: "Thinker Playground",
  APP_CREATOR: "Thinker Tech",
  LANGUAGES: ["en", "my"],
  PATHS: [
    { icon: "\u2302", label: "Home", to: "/" },
    { icon: "\u24d8", label: "About", to: "/about" },
    { icon: "\u29c9", label: "Theme", to: "/theme" }
  ],
  THEMES: [
    "bootstrap",
    "cerulean",
    "cosmo",
    "cyborg",
    "darkly",
    "flatly",
    "journal",
    "litera",
    "lumen",
    "lux",
    "materia",
    "minty",
    "pulse",
    "sandstone",
    "simplex",
    "sketchy",
    "slate",
    "solar",
    "spacelab",
    "superhero",
    "united",
    "yeti"
  ],
  TAGLINE: "Let's think 🤔 together to make 🌏 better tomorrow 🚀",
  LINK: "https://www.thinkertech.io",
  EMAIL: "nieylarm+thinkertech@gmail.com",
  COUNTRY: "🇲🇾 Malaysia",
  SINCE: "2019"
};

export default Constant;
